import HideIf from "util/HideIf";
import styles from "./star-ratings.module.scss";

interface IProps {
  rating: number;
  filled?: boolean;
  className?: string;
  enableHalfRating?: boolean;
}

function StarRatings(props: IProps) {
  const {
    rating = 5, filled, className, enableHalfRating = true,
  } = props;
  const showHalfRating = enableHalfRating && rating - Math.floor(rating) >= 0.5;
  const emptyStarRating = 5 - (showHalfRating ? Math.round(rating) : Math.floor(rating));
  return (
    <div className={styles.star_ratings}>
      {[...Array(Math.floor(rating))].map((_, idx) => (
        <i key={idx} className={`fa fa-star ${className}`} />
      ))}

      <HideIf show={showHalfRating}>
        <i className={`fa fa-star-half-o ${className}`} />
      </HideIf>
      {filled
        && [...Array(emptyStarRating)].map((_, idx) => (
          <i key={idx} className={`fa fa-star-o ${className}`} />
        ))}
    </div>
  );
}

export default StarRatings;
